import { FC } from 'react'
import { getHolidays } from 'services/Holidays'
import { openModal } from 'store/actions/modals'

import { store } from 'store/reducers'
import { Badge } from 'ui'

type Header = {
  level: number
  start: { value: string; toString: (string: string, lang: 'fr-fr' | 'en-ca') => string }
}
interface Props {
  header: Header
  view: 'weekly' | 'daily'
  localeLang: 'fr-fr' | 'en-ca'
  dispatch: (action: unknown) => void
  notes: Record<string, { note: string; day: string }>[]
}

const SchedulerHeader: FC<Props> = props => {
  const { header, view, localeLang, dispatch, notes } = props
  const {
    settings: { enableScheduleNotes }
  } = store.getState() as MStore.RootState

  const isWeekly = view === 'weekly'
  const holidaysInHeaderDay = getHolidays(header.start.value)

  const hasNote = !!notes?.[header.start.value]?.note.length ?? false

  return (
    <div className={`d-flex ${isWeekly ? 'flex-column' : 'justify-content-center'}`}>
      <div>
        <span>
          {header.level === 0 ? header.start.toString(`${isWeekly ? 'dddd d' : 'dddd d MMMM yyyy'}`, localeLang) : header.start.toString('H', localeLang)}
        </span>
        {header.level === 0 && enableScheduleNotes ? (
          <SchedulerHeaderIcon hasNote={hasNote} openModal={() => dispatch(openModal('ScheduleNotesModal', { payload: { start: header.start.value } }))} />
        ) : null}
      </div>

      {!!holidaysInHeaderDay.length && header.level === 0 && (
        <Badge variant="success" className={`${isWeekly ? 'align-self-center mt-1' : 'ml-1'}`}>
          {holidaysInHeaderDay.length === 1 ? holidaysInHeaderDay[0].name : holidaysInHeaderDay.map(({ name }) => name).join(',')}
        </Badge>
      )}
    </div>
  )
}
type SchedulerHeaderIcon = {
  hasNote: boolean
  openModal: () => void
}

export const SchedulerHeaderIcon: FC<SchedulerHeaderIcon> = ({ openModal, hasNote }) => {
  return <i className={`fa ml-2 cursor-pointer  ${hasNote ? 'fa-notes' : 'text-muted fa-note-medical'}`} onClick={openModal}></i>
}

export default SchedulerHeader
